import { render, staticRenderFns } from "./quote-create.vue?vue&type=template&id=06f66ac1&"
import script from "./quote-create.vue?vue&type=script&lang=js&"
export * from "./quote-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports